import axios from "axios";
import { environment } from "../../environments/environment";

export interface Postcode {
    logradouro: string,
    bairro: string,
    cidade: string,
    uf: string,
    city_id: string
}

export const retrievePostcodeInfo = async (postcode: string) => {
    const normalizedPostcode = postcode.replace(/[^0-9]+/g, '');
    if (normalizedPostcode.length !== 8) {
        throw new Error('CEP inválido');
    }

    const response = await axios.get<Postcode>(`${environment.apiUrl}/api/cep/${normalizedPostcode}`);

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
}